import { resourceApi } from './resourceApi.js'
import { advertisementApi } from './advertisement.js'
import { integrationApi } from './integration.js'

export const resourceServe = {
  ...resourceApi,
  ...advertisementApi,
  ...integrationApi,
}
